<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPerson"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th class="ButtonWidth"></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>

				<th class="ButtonWidth">
					<button class="btn btn-danger" (click)="onRemoveAll()">
						<i class="fa fa-trash-o" style="margin: 0px" aria-hidden="true"></i>
					</button>
				</th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Person[col.field] }}
				</td>

				<td class="ButtonWidth">
					<button class="btn btn-danger" (click)="onRemove(Person)">
						<i class="fa fa-times" style="margin: 0px" aria-hidden="true"></i>
					</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
